import React, { useState } from "react";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import Dated from "@mapmycustomers/shared/types/base/Dated";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import Named from "@mapmycustomers/shared/types/base/Named";
import User from "@mapmycustomers/shared/types/User";

import ListDrawer, { ListDrawerProps } from "@app/component/ListDrawer";
import SortField from "@app/component/ListDrawer/enum/SortField";

import Footer from "./Footer";

interface Props<T> extends ListDrawerProps<T> {}

const ListDrawerWithPagination = <T extends Identified & Named & Dated<Date>>({
  deleteConfirmationText,
  icon,
  information,
  items,
  onDelete,
  onEdit,
  onHide,
  onSelect,
  paneTitle,
  rowSubTitleGetter,
  rowTitleGetter = ({ name }) => name,
  selectConfirmationConfirmText,
  selectConfirmationText,
  visible,
}: Props<T>) => {
  const [filtersPerPage, setFiltersPerPage] = useState(items.slice(0, 20));
  const [order, setOrder] = useState<SortOrder>(SortOrder.DESC);
  const [field, setField] = useState<SortField>(SortField.UPDATED_AT);
  const [search, setSearch] = useState<string>("");
  const [creatorIds, setCreatorIds] = useState<User["id"][]>([]);

  return (
    <ListDrawer<T>
      customFooter={
        <Footer
          creatorIds={creatorIds}
          field={field}
          items={items}
          onChangePage={setFiltersPerPage}
          order={order}
          search={search}
        />
      }
      deleteConfirmationText={deleteConfirmationText}
      icon={icon}
      information={information}
      items={filtersPerPage}
      onChangeSortField={setField}
      onChangeSortOrder={setOrder}
      onDelete={onDelete}
      onEdit={onEdit}
      onHide={onHide}
      onSearch={setSearch}
      onSelect={onSelect}
      onSelectCreatorIds={setCreatorIds}
      paneTitle={paneTitle}
      rowSubTitleGetter={rowSubTitleGetter}
      rowTitleGetter={rowTitleGetter}
      selectConfirmationConfirmText={selectConfirmationConfirmText}
      selectConfirmationText={selectConfirmationText}
      visible={visible}
    />
  );
};

export default ListDrawerWithPagination;
